module.exports = "<v-dropdown [options]=\"languages\" [(ngModel)]=\"selectedLanguage\">\n</v-dropdown>\n";